import { enableProdMode, Injector } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import 'hammerjs';

if (environment.production) {
  enableProdMode();
}

// Register service worker
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.register('firebase-messaging-sw.js')
    .then((registration) => {
      console.log('service worker Registered', registration);
    }).catch((error) => {
      console.error('service failed', error);
    });
}

fetch(`${environment.serverAPI4}/api/ig/config`)
  .then(response => response.json())
  .then(config => {
    // Initialize Firebase here
    console.log('Fetched config:', config);
    const firebaseConfig = {
      apiKey: config.apiKey,
      authDomain: config.authDomain,
      projectId: config.projectId,
      storageBucket: config.storageBucket,
      messagingSenderId: config.messagingSenderId,
      appId: config.appId
    };

    environment.firebase = firebaseConfig;

    // Bootstrap the app
    platformBrowserDynamic()
      .bootstrapModule(AppModule)
      .catch(err => console.error(err));
  })
  .catch(err => {
    console.error('Failed to fetch Firebase config', err);
    // fallback bootstrap if needed
    platformBrowserDynamic().bootstrapModule(AppModule);
  });